import React from 'react';
import { Link } from 'react-router-dom';
import { LUX_CSS, useLuxMotion } from './LuxShared';

const PILLARS = [
  {
    num: '01',
    title: 'Firebucks Catalyst',
    tag: 'For enterprises',
    img: '/nh-media/svc-transform.jpg',
    main: '/firebucks-catalyst',
    desc: 'Product-as-a-Service and design-led delivery for organisations shipping at scale — and for the enterprise engagements you already have.',
  },
  {
    num: '02',
    title: 'Firstspark',
    tag: 'For founders',
    img: '/nh-media/svc-product.jpg',
    main: '/firstspark',
    desc: 'The founder-facing door. We bring the engineering and technicality founders need to build the first version and grow.',
  },
];

const ServicesLux = () => {
  const rootRef = useLuxMotion();
  return (
    <div className="fx-root" ref={rootRef}>
      <style>{LUX_CSS}</style>

      <section className="fx-hero">
        <video className="fx-hero-video" muted loop playsInline autoPlay preload="auto" src="/nh-media/services-tech.mp4" />
        <div className="fx-hero-scrim" />
        <div className="fx-hero-inner">
          <h1 className="fx-reveal">Engineering that ships. <span className="fx-accent">At any scale.</span></h1>
          <p className="fx-reveal">Same DNA, two clear doors — one for enterprises shipping at scale, one for founders starting from zero. One senior team, end to end.</p>
        </div>
      </section>

      <section className="fx-section">
        <div className="fx-wrap">
          <div className="fx-head fx-reveal">
            <h2>Two ways to <span className="fx-accent">work with us</span></h2>
            <p>Whether you're an enterprise shipping at scale or a founder starting from zero, there's a door built for you.</p>
          </div>
          <div className="fx-grid fx-grid-2">
            {PILLARS.map((p) => (
              <Link key={p.num} to={p.main} className="fx-card fx-tilt fx-reveal fx-card-link">
                <div className="fx-card-accent" />
                <div className="fx-card-media"><img src={p.img} alt={p.title} loading="lazy" /></div>
                <div className="fx-card-body">
                  <div className="fx-card-num">{p.tag}</div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="fx-section fx-soft">
        <div className="fx-wrap">
          <div className="fx-head fx-reveal">
            <h2>Why teams bring us in</h2>
          </div>
          <div className="fx-stats">
            {[
              ['Weeks', 'not quarters to first release'],
              ['Senior', 'only pods, no bench padding'],
              ['ISO 9001', 'certified delivery process'],
              ['3', 'global delivery hubs'],
            ].map(([b, s]) => (
              <div key={s} className="fx-stat fx-pop"><b>{b}</b><span>{s}</span></div>
            ))}
          </div>
        </div>
      </section>

      <section className="fx-cta">
        <video className="fx-cta-video" muted loop playsInline autoPlay preload="none" src="/nh-media/cta-tech.mp4" />
        <div className="fx-cta-scrim" />
        <div className="fx-cta-inner">
          <h2 className="fx-reveal">Not sure which pillar you need?</h2>
          <p className="fx-reveal">Tell us the outcome you're chasing. We'll tell you the shortest path to it.</p>
          <Link className="fx-btn fx-pop" to="/contact-us">Talk to Firebucks <span className="fx-arr">→</span></Link>
        </div>
      </section>
    </div>
  );
};

export default ServicesLux;
